import api from './api';

const obtemImpressao = async (endpoint, params) => {
  const popup = window.open('', '_blank');

  if (!popup) {
    throw new Error('Desbloqueie as pop-ups para este site');
  }

  try {
    const response = await api.get(endpoint, { params, responseType: 'blob' });
    const blob = response instanceof Blob
      ? response
      : new Blob([response], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);

    popup.location.href = url;
    popup.focus();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 5 * 60 * 1000);
  } catch (error) {
    popup.close();
    throw error;
  }
};

export default obtemImpressao;



// WEBPACK FOOTER //
// ./src/services/obtemImpressao.js